import { Card, Checkbox, Drawer } from 'antd';
import styled from 'styled-components';

export const StyledCheckboxGroup = styled(Checkbox.Group)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;

  .ant-checkbox {
    display: none;
  }

  .ant-card-head-title {
    font-size: 18px;
    font-weight: 400;
    color: #000;
  }

  .ant-card-body {
    border-top: 1px solid #e5e5e5;
    background: #f5f5f5;
  }
`;

export const StyledTitle = styled.div`
  display: flex;
  align-items: center;

  .title {
    margin-right: 10px;
  }

  sup {
    color: #999;
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-inline-start: 0 !important;
  cursor: default;
`;

export const ManageFooter = styled.div`
  display: flex;
  gap: 10px;
`;

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-header-title {
    flex-direction: row-reverse;

    .ant-drawer-title {
      font-size: 22px;
      font-weight: 400;
    }
  }

  .ant-drawer-body {
    padding-top: 10px;
  }
`;

export const StyledCard = styled(Card)`
  width: 330px;
  border: 2px solid #e5e5e5;
  height: 265px;
  display: flex;
  flex-direction: column;
  border-color: #e5e5e5;

  .ant-card-body {
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    display: flex;
  }
`;

export const StyledInputBox = styled.div`
  display: flex;
  gap: 5px;
`;

export const InputNumber = styled.div`
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
`;

export const WarningText = styled.div`
  margin: 10px 0 20px 8px;

  .anticon {
    margin-right: 10px;
  }
`;
